import React from "react";

import Chip from "@material-ui/core/Chip";

const UACell = (rowData) => {
  if (!rowData.context) return null;
  let ua = rowData.context.ua_details || {};
  return (
    <React.Fragment>
      <Chip
        label={`${(ua.client||{}).name} ${(ua.client||{}).version}`}
        size="small"
        color="primary"
        variant="outlined"
      />          
      <br />
      <Chip label={`${(ua.os||{}).name} ${(ua.os||{}).version}`} size="small" />

     
    </React.Fragment>
  );
};

export default UACell;
